// extracted by mini-css-extract-plugin
export default {"wrap":"ButtonEdit_wrap__fq073","icon":"ButtonEdit_icon__-JYHp"};